export default "__VITE_ASSET__e33108c8__"